"use strict";
exports.__esModule = true;
exports.SLC_APPROVED_MODAL_CONTENT = void 0;
exports.SLC_APPROVED_MODAL_CONTENT = {
    HEADER: 'You’re Approved!',
    BODY: 'You have a {{rentAmount}} Flex secured line of credit to pay your rent in full and on time.',
    CTA: 'Continue'
};
